<div class="flex w-100vw justify-between pl-1 pt-1" [class.pointer-events-none]="isDisabled()">
  <div class="bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/logo-h-color-white.svg)] bg-left bg-auto bg-no-repeat flex-auto h-19 md:ml-4 cursor-pointer" [routerLink]="['/home']">

  </div>
  <div class="flex mt-3 mr-4 md:mr-8">
    <app-link class="leading-12 hidden md:block" *ngFor="let route of routes" [text]="route.label" [routerLink]="[route.path]" route="/{{route.path}}"></app-link>
    <app-menu-toggle *ngIf="!isDisabled()"></app-menu-toggle>

  </div>
</div>

